import { IAppState } from '../common/state';

export function mortgageDataFlatRatesSelector(state: IAppState) {
  return state.mortgageData?.rates.flat;
}
